
var ServiceUrlDomain = {
	test: "https://gisservicest.bnsf.com/",
	dev: "https://gisservicesdv.bnsf.com/",
	trial: "https://gisservicestr.bnsf.com/",
	prod: "https://gisservices.bnsf.com/"
};

function _dataServicesRootUrl(env) {
	// set the runtime service url domain based on env value; set to prod by default
	var dataServiceUrlDomain = env && ServiceUrlDomain[env] ? ServiceUrlDomain[env] : ServiceUrlDomain["prod"];

	return dataServiceUrlDomain + "GritDataAccessRestWS/rest";
}

/**
 * return the data service url for a given subdivision
 * @param subdiv {String} Subdivision short name
 * @param env {String} "test" | dev" | "trial" | "prod", runtime environment of the TMDS data service
 * @param tmdsEnv {String} TMDS environment. Only used for TEST environment where multiple TMDS environments are supported
 */
function _dataServiceUrlBySub(endPoint, subdiv, env, tmdsEnv) {
	var urlTemplate = _dataServicesRootUrl(env) + endPoint;

	if (env === "test" && tmdsEnv) {
		urlTemplate += "?tmdsEnv=" + tmdsEnv;
	}

	return urlTemplate.replace("{subName}", subdiv);
}

module.exports = {
	/**
	 * return the service url to get the schematic data for a given subdivision
	 * @see dataUrlBySub for param description
	 */
	tmdsUrl: function (subdiv, env, tmdsEnv) {
		return _dataServiceUrlBySub("/getData/{subName}/all", subdiv, env, tmdsEnv);
	},

	/**
	 * return the service url to get the milepost range data (originated in mainframe) for a given subdivision
	 * @see dataUrlBySub for param description
	 */
	mpRangeUrl: function (subdiv, env, tmdsEnv) {
		return _dataServiceUrlBySub("/getData/{subName}/mprange", subdiv, env, tmdsEnv);
	},

	/**
	 * return the service url for the milepost range graph of a given subdivision
	 * @see dataUrlBySub for param description
	 */
	mpRangeGraphUrl: function (subdiv, env, tmdsEnv) {
		return (env === "dev") ? _dataServiceUrlBySub("/getData/{subName}/mpgraph", subdiv, env, tmdsEnv) : "";
	}
};